// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__tpDUX"};